export const BUSINESS_ROUTE = 'business';
export const ADVERTISEMENTS_ROUTE = 'advertisements';
export const DASHBOARD_ROUTE = 'dashboard';

export const LAST_SEVEN_DAYS = 'LAST_SEVEN_DAYS';
export const LAST_THIRTY_DAYS = 'LAST_THIRTY_DAYS';
export const THIS_MONTH = 'THIS_MONTH';
export const FROM_ORIGIN = 'FROM_ORIGIN';

export const GET_SECTOR_DATA = 'getSectorData';
